import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { UriApi } from '../helpers/UriApi';

declare const window: any;
@Injectable({ providedIn: 'root' })
export class NaverMapService {
    constructor(private http: HttpClient, private router: Router) { }

    getLatLng(Address: any) {
        return this.http.get(UriApi.GetGeocoding, { params: { Address: Address }});
    }

} 